<template>
  <div id="app">
    <vue-extend-layouts />
    <v-dialog width="500px" />
  </div>
</template>

<script>

import VueExtendLayouts from "vue-extend-layout";
import { HIDE_SIDE_BAR } from './store/actions.type';

import './assets/styles/shared/dialog.css'

export default {
	components: { VueExtendLayouts },
	created: function() {
		let vm = this;

		document.addEventListener('click', function(e) {
			vm.closeSideBar(e);
		});
	},
	methods: {
		closeSideBar: function(e) {			
			let bars = document.getElementById('nav-bar')

			const isBars = 	bars == e.target || 
							bars == e.target.parentElement;

			if(isBars)
				return;

			if(!isBars)
				this.$store.dispatch(HIDE_SIDE_BAR);
		}
	},
	destroyed: function() {
		let vm = this;

		document.removeEventListener('click', function(e) {
			vm.closeSideBar(e);
		});
	}
};

</script>
